import React, { useRef, useState } from "react";
import PropTypes from "prop-types";
import FileTokenService from "~/services/FileTokenService";
import { FileTokenContextProvider } from "./context";

export const FileTokenProvider = ({ children }) => {
  const intervalRef = useRef();
  const [state, setState] = useState({
    thumb_token: "",
    preview_token: "",
    download_token: "",
    ttl: 0,
  });

  React.useEffect(() => {
    const handler = () => {
      FileTokenService.getTokens().then((data) => {
        setState(data);
      });
    };

    intervalRef.current = setInterval(handler, 3600000);

    handler();

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  return <FileTokenContextProvider value={state}>{children}</FileTokenContextProvider>;
};

FileTokenProvider.propTypes = {
  children: PropTypes.node,
};
